import { createApp } from 'vue';
import Http from '@/http/api';
import App from './App.vue';
import router from './router';
import 'amfe-flexible/index';
import '@/assets/common.scss';

const app = createApp(App);
app.config.globalProperties.$http = Http;
app.use(router).mount('#app');
